
import EmailComponent from "../components/EmailComponent";
import Timeline from "../components/Timeline";
import aboutLogo from "../images/10.png";
import chooseToLive from "../images/I choose to live.png";
import { FaArrowRight } from 'react-icons/fa';
const { default: Footer } = require('../components/Footer');
const { default: Header } = require('../components/Header');

function About() {
    return (
        <div className="mb-[120px] md:mb-0">
            <Header transparent={false} pageName="About" />
            <div className="background-with-image-blue pt-32 md:pt-40 ">
                {/* Image Section */}
                <div className="">
                    <img
                        src={aboutLogo}
                        alt="Logo"
                        className="mx-auto w-[90%] md:w-[60%]"
                    />
                </div>
                <div className="container mx-auto pt-4 md:pt-16 pb-16 px-8 md:px-0 relative">
                    <p className="text-center poppins mx-auto text-lg md:text-3xl lg:text-5xl mb-8 hidden md:block">I want to share a piece of my story.<br />
                     Not the polished version, but the one that<br /> shaped me.</p>
                    <p className="text-center poppins mx-auto text-xl md:text-3xl lg:text-5xl mb-8 block md:hidden">I want to share <br />a piece of my story.<br />
                    Not the polished version,<br /> but the one that shaped me.</p>
                    <div className="flex flex-col md:flex-row">
                        <div className="flex">
                            <p className="poppins text-lg md:text-2xl font-light text-justify md:px-8">
                                I remember wishing for just one thing:
                                room to breathe. Room to be myself.
                                And then came the diagnosis: I was
                                given 6 to 8 months to live. Nothing
                                prepares you for words like that.
                                Twenty-six years ago, I reached a
                                moment where I had to choose: fade
                                quietly, or fight for a life that actually felt
                                like mine.
                            </p>
                        </div>
                        <div className="flex">
                            <p className="poppins text-lg md:text-2xl font-light text-justify pt-8 md:pt-0 md:px-8">That was the first time I set a goal for
                                myself; to take back my life, piece by
                                piece, and rebuild it in a way that felt
                                honest, peaceful and mine. I held onto
                                one belief through everything: every
                                person deserves a life where they can
                                choose joy and safety for themselves.</p>
                        </div>
                    </div>
                    <div className="flex justify-center md:justify-end">
                        <img
                            src={chooseToLive}
                            alt="Logo"
                            className="w-[18em] pt-16 md:pt-8"
                        />
                    </div>
                </div>
            </div>


            <div className='bg-[#edebe6]'>
                <Timeline />
            </div>
            <EmailComponent />
            <Footer isblue={true} />
        </div>
    );
}
export default About;